<template>
  <main-layout
    class="supplier-workbench"
    page-title="产销对接工作台"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content">
      <div class="base-info-box">
        <div class="name">
          {{ farmName }}
        </div>
        <div class="score-box">
          <div class="score">{{ totalScore === null ? "--" : totalScore }}</div>
          <div class="tips">综合评分，明细请在神农口袋APP查看</div>
        </div>
        <div
          class="look-home-page"
          @click="showModal = true"
          v-click-out-side="closeModal"
        >
          <i class="iconfont scan icon-a-Scan-codesaoma"></i
          ><span>查看我的主页</span>
          <div class="modal-box" v-if="showModal">
            <div class="text">
              您已开通产销对接功能，可扫码查看自己在神农直采中的农场主页。
            </div>
            <div class="qrcode-box"><img :src="qrCode" alt="" /></div>
            <img
              class="triangle"
              :src="require('@/assets/images/supplier/triangle.png')"
            />
          </div>
        </div>
      </div>
      <div class="purchaser-list-box">
        <div class="title">平台入驻采购商</div>
        <div class="list">
          <div
            class="item"
            v-for="item in purchaserList"
            :key="item.purId"
            @click="toDetail(item.purId)"
          >
            <div class="avatar">
              <img v-if="item.imgUrl" :src="formatAvatar(item.imgUrl)" alt="" />
              <img
                v-else
                :src="require('@/assets/images/supplier/default-avatar.png')"
                alt=""
              />
            </div>
            <div class="text">
              <div class="name">
                {{ item.purName }}
              </div>
              <div class="desc">
                <span class="c1">正在找</span>
                <template
                  v-if="
                    item.followVOList &&
                    item.followVOList.length &&
                    item.isPurTourist === '0'
                  "
                >
                  <span
                    class="c2"
                    v-for="crop in item.followVOList"
                    :key="crop.secondId"
                    >{{ crop.secondName }}</span
                  >
                </template>
                <template v-else><span class="c2">--</span></template>
              </div>
            </div>
          </div>
          <div v-if="totalCount > 8" class="item more" @click="openModal">
            查看更多采购商 <i class="iconfont icon-Vector1-copy-copy"></i>
          </div>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import {
  getPurchaserList,
  getSupplierInfo,
  getWxQrCode,
} from "@/api/request/snkd.purchase";
import { getFarmAllScore } from "@/api/request/snkd.produce";
import modal from "./mixins/modal";
import { setImgUrl } from "@/utils";
export default {
  mixins: [modal],
  components: { MainLayout },
  data() {
    return {
      farmName: "",
      supId: null,
      totalScore: null,
      qrCode: "",
      showModal: false,
      purchaserList: [],
      totalCount: 0,
    };
  },
  mounted() {
    this.getSupplierInfo();
    this.getFarmScore();
    this.getWxQrCode();
    this.getPurchaserList();
  },
  methods: {
    toDetail(purId) {
      this.$router.push({
        path: "/supplier/purchaserDetail",
        query: { purId, supId: this.supId },
      });
    },
    async getSupplierInfo() {
      const res = await getSupplierInfo();
      console.log("供应商信息===", res);
      if (res.respCode === 0) {
        const { farmName, supId } = res.obj;
        this.farmName = farmName;
        this.supId = supId;
      }
    },
    async getFarmScore() {
      const res = await getFarmAllScore();
      console.log("农场分数===", res);
      if (res.respCode === 0) {
        this.totalScore =
          res.obj.totalScore === null
            ? null
            : Number(parseFloat(res.obj.totalScore).toFixed(1));
      }
    },
    async getWxQrCode() {
      const envVersion =
        process.env.VUE_APP_ENV === "prod" ? "release" : "trial";
      console.log("envVersion====", envVersion);
      const res = await getWxQrCode({ envVersion, jumpType: 0 });
      console.log("获取二维码===", res);
      this.qrCode = `data:image/png;base64,${res.obj}`;
    },
    async getPurchaserList() {
      const res = await getPurchaserList({ pageNo: 1, pageSize: 8 });
      console.log("获取采购商列表====", res);
      if (res.respCode === 0) {
        this.totalCount = res.obj.totalCount;
        this.purchaserList = res.obj.list;
      }
    },
    closeModal() {
      this.showModal = false;
    },
    formatAvatar(path) {
      return setImgUrl(path, 140, 140);
    },
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>
<style lang="scss">
@import "~@/assets/style/download-guide-popup.scss";
</style>
<style scoped lang="scss">
@font-face {
  font-family: "DingTalk";
  src: url("~@/assets/fonts/DingTalk.ttf");
}
.supplier-workbench {
  .main-content {
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    padding-top: 50px;
    background: #ffffff;
    margin: 0 auto;
  }
  .base-info-box {
    position: relative;
    width: 960px;
    height: 207px;
    box-sizing: border-box;
    padding: 30px 0 0 60px;
    border-radius: 8px;
    background-image: url("../../assets/images/supplier/baseinfo-bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 0 auto;
    .name {
      width: 424px;
      font-size: 20px;
      font-weight: bold;
      line-height: 28px;
      color: #ffffff;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .score-box {
      position: absolute;
      left: 60px;
      bottom: 29px;
      .score {
        color: #64ff2e;
        font-size: 50px;
        font-family: "DingTalk";
        line-height: 60px;
      }
      .tips {
        color: #bde7d7;
        font-size: 16px;
      }
    }
    .look-home-page {
      position: absolute;
      right: 62px;
      bottom: 21px;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      > .scan {
        font-size: 22px;
        margin-right: 2px;
      }
      .modal-box {
        position: absolute;
        top: 36px;
        right: -62px;
        width: 405px;
        height: 156px;
        box-sizing: border-box;
        padding-left: 20px;
        display: flex;
        align-items: center;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        background: #ffffff;
        z-index: 100;
        .text {
          width: 194px;
          line-height: 160%;
          color: #333;
          font-size: 16px;
          margin-right: 40px;
        }
        .qrcode-box {
          width: 110px;
          height: 110px;
          > img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        .triangle {
          position: absolute;
          right: 111px;
          top: -10px;
          display: block;
          width: 19px;
          height: 14px;
        }
      }
    }
  }
  .purchaser-list-box {
    padding: 58px 120px 100px 120px;
    background: #ffffff;
    .title {
      color: #333;
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 23px;
    }
    .list {
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 304px;
        height: 106px;
        box-sizing: border-box;
        padding: 0 16px;
        display: flex;
        align-items: center;
        border-radius: 10px;
        background: linear-gradient(180deg, #fdfdfd 0%, #fff 100%);
        box-shadow: 0 0 20px 0 rgba(167, 183, 198, 0.3);
        margin-right: 24px;
        margin-bottom: 24px;
        cursor: pointer;
        &:hover {
          box-shadow: 0 0 20px 0 rgba(100, 195, 164, 0.4);
          .text {
            .name {
              color: #64c3a4;
            }
          }
        }
        &:nth-child(3n + 3) {
          margin-right: 0;
        }
        &.more {
          justify-content: center;
          color: #64c3a4;
          font-size: 16px;
          &:hover {
            background: #64c3a4;
            color: #ffffff;
          }
          .iconfont {
            font-size: 14px;
          }
        }
        .avatar {
          width: 70px;
          height: 70px;
          min-width: 70px;
          border-radius: 10px;
          border: 1px solid #eff2f6;
          overflow: hidden;
          margin-right: 12px;
          > img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        .text {
          width: 190px;
          .name {
            width: 100%;
            font-size: 16px;
            color: #333333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .desc {
            width: 100%;
            font-size: 12px;
            line-height: 20px;
            margin-top: 9px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            span {
              display: inline;
              margin-right: 8px;
            }
            .c1 {
              color: #9296a4;
            }
            .c2 {
              color: #666666;
            }
          }
        }
      }
    }
  }
}
</style>
